import React from "react";
import DocumentAchatEntity from "./DocumentAchatEntity";

const BonCommandeAchat = () => {
    return <DocumentAchatEntity type="Bon Commande" title="Bons Commande" endpoint="BonCommandeAchat" />;
};

export default BonCommandeAchat;
